<template>
  <div class="full-width-container" :style="`background-image: url(${moduleData.src || ''})`">
  </div>
</template>

<script>
export default {
  props: {
    moduleData: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
.full-width-container {
  background-position: center center;
  background-attachment: fixed;
  height: 600px;
}
</style>